<nb-card id="registrationId">
  <nb-card-header class="d-flex justify-content-end align-content-center">
    <button mat-icon-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </nb-card-header>
  <nb-card-body class="p-0 m-0">
    <div class="row p-0 m-0">
      <div class="col-12" *ngIf="editUrl">
        <iframe [src]="targetUrl" allow="clipboard-read; clipboard-write"></iframe>
      </div>
    </div>
  </nb-card-body>
</nb-card>
